"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isFetchingPreviews = false;
        _this.articlePreviews = [];
        return _this;
    }
    App.prototype.created = function () {
        this.isFetchingPreviews = true;
        this.fetchPreviews();
    };
    App.prototype.fetchPreviews = function () {
        var _this = this;
        this.$http.get('/articles/' + this.slug + '/get-related')
            .then(function (res) {
            if (!res.data) {
                return;
            }
            if (!Array.isArray(res.data.articles)) {
                throw new Error('Articles must be array');
            }
            _this.articlePreviews = res.data.articles;
            _this.isFetchingPreviews = false;
        });
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true })
    ], App.prototype, "slug", void 0);
    App = __decorate([
        vue_property_decorator_1.Component
    ], App);
    return App;
}(vue_1.default));
exports.default = App;
